module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.data[_vm.type].name))]), _vm._v(" "), _c('div', {
    class: (_vm.type + "-group color-group pure-g")
  }, _vm._l((_vm.data[_vm.type].colors), function(name, key, i) {
    return _c('div', {
      key: i,
      class: ['color-item-wrap', ("pure-u-" + (24 / _vm.data[_vm.type].colors.length) + "-24")]
    }, [_c('div', {
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "color-name"
    }, [_vm._v(_vm._s(name))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71179b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Color.vue
// module id = 674
// module chunks = 0